import router from './router';
import store from './store';
import { getToken } from '@/utils/auth'; // get token from cookie

router.beforeEach(async (to, from, next) => {
    // 判断 cookie 中是否有 token
    const hasToken = getToken();
    if (hasToken) {
        // 如果有 token
        if (to.path === '/login') {
            // 进入主页
            next({ path: '/' });
        } else {
            await store.dispatch('permission/generateRoutes', []);
            await store.dispatch('user/getUserRoles');
            next();
        }
    } else if (to.path === '/login' || to.path === '/register') {
        next();
    } else {
        next({ path: '/login' });
    }
});



// WEBPACK FOOTER //
// ./src/permission.js